import React from 'react';
import PropTypes from 'prop-types';
import { Marker, OverlayView } from 'react-google-maps';
import StarIcon from '@material-ui/icons/Star';
import defaultBikeAvailableIcon from '../../assets/bikeAvailableIcon.png';

const sponsoredBadgeStyle = {
  alignItems: 'center',
  background: '#FDE900',
  border: '1px solid rgba(0, 0, 0, 0.28)',
  borderRadius: '50%',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.35)',
  cursor: 'pointer',
  display: 'flex',
  height: 20,
  justifyContent: 'center',
  width: 20,
};

const sponsoredIconStyle = {
  color: '#333',
  fontSize: 15,
};

const getSponsoredBadgeOffset = (width, height) => ({
  x: -width / 2 + 11,
  y: -height - 4,
});

const BikeMarker = ({ bike, isSelected, onSelect, ...other }) => {
  const getIcon = bikeIconUrl => {
    return {
      url: bikeIconUrl,
      /* eslint-disable no-undef */
      scaledSize: new google.maps.Size(32, 32)
    };
  };

  return (
    <React.Fragment>
      <Marker
        icon={getIcon(bike.icon || defaultBikeAvailableIcon)}
        position={bike.location}
        title={`Rower: ${bike.bikeNumber}`}
        {...other}
        onClick={() => onSelect && onSelect(bike)}
        animation={isSelected && window.google.maps.Animation.BOUNCE}
      />
      {bike.isSponsored && (
        <OverlayView
          position={bike.location}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getSponsoredBadgeOffset}
        >
          <div
            title="Rower sponsorski"
            style={sponsoredBadgeStyle}
            onClick={() => onSelect && onSelect(bike)}
          >
            <StarIcon style={sponsoredIconStyle} />
          </div>
        </OverlayView>
      )}
    </React.Fragment>
  );
};

BikeMarker.propTypes = {
  bike: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default BikeMarker;
